export const useRouteParams = <P>() =>
{
    const route = useRoute()
    return route.params as P
}